<ng-container [formGroup]="formGroup">
  <ng-container [formGroupName]="blockFormName">
    <div fxLayout="column">
      <app-form-render-label [item]="item"></app-form-render-label>
      <mat-progress-bar [mode]="'indeterminate'" *ngIf="loading"></mat-progress-bar>
      <mat-form-field appearance="outline" fxFlex="calc(90% - 25px)">
        <mat-select [formControlName]="item.key" placeholder="{{item.options_obj.placeholder}}" [attr.data-cy]="'select-form-render-'+item.id">
          <ng-container *ngIf="!item.options_obj.isRequired">
            <mat-option [value]="nullValues.List.value" data-cy="option-form-render-svccmp-list">
              {{nullValues.List.render}}
            </mat-option>
          </ng-container>
          <mat-option *ngFor="let entite of listSvcCmp" [value]="entite.entite" [attr.data-cy]="'option-form-render-svccmp'+entite.id">
            {{entite.entite_obj?.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>
</ng-container>
